export const MonturesOptions = [
  {
    key: "empty",
    text: "",
    value: "",
  },
  {
    key: "1",
    text: "Monture pour vision de loin + verres correcteurs",
    value: "Monture pour vision de loin + verres correcteurs",
  },
  {
    key: "2",
    text: "Monture pour enfant + verres correcteurs",
    value: "Monture pour enfant + verres correcteurs",
  },
  {
    key: "3",
    text: "Monture + verres correcteurs progressifs",
    value: "Monture + verres correcteurs progressifs",
  },
  {
    key: "4",
    text: "Monture pour VL + VP + verres correcteurs",
    value: "Monture pour vision de loin + vision de près + verres correcteurs",
  },
  {
    key: "5",
    text: "Monture pour vision de près + verres correcteurs",
    value: "Monture pour vision de près + verres correcteurs",
  },
];
